import React, { Component } from "react";
import ReactDOM from "react-dom";

export default class EditorToolbarPortal extends Component {
    constructor() {
        super()
        this.el = document.createElement('div');
    }
    componentDidMount() {
        // put the portal in the nav bar in the Home Component
        const book = document.getElementById("nav")
        book.appendChild(this.el);
    }
    render() {
        return ReactDOM.createPortal(
          this.props.children,
          this.el
        );
      }
        
}


// WEBPACK FOOTER //
// ./src/containers/editorToolBar/EditorToolbarPortal.js